import blogPosts from "../data/blogPostsData";

export const getLatestBlogPosts = (limit = 3) => blogPosts.slice(0, limit);

export const getRandomRelatedBlogPosts = (currentSlug, limit = 3) => {
  const candidates = blogPosts.filter((post) => post.slug !== currentSlug);

  return [...candidates]
    .sort(() => Math.random() - 0.5)
    .slice(0, limit);
};

export const getBlogCardImage = (post) =>
  post.image || "/cursos-enfermeria-quiropractica-nican.png";

export const getBlogCardImageAlt = (post) =>
  post.imageAlt || `${post.title} | Fundacion Nican`;
